<template>
  <div>
    <page-model @close="closeModel" :visible="visibleValue">
      <div class="confirm">
        <div class="title">{{title}}</div>
        <div class="content">{{content}}</div>
        <div class="desc">{{desc}}</div>
        <div class="footer">
          <a-button :loading="isLoadding" style="width:100px" @click="sureClick" type="primary">确定</a-button>
          <a-button
            @click="closeModel"
            style="width:100px;margin-left:16px;"
            class="ant-btn-custom"
          >取消</a-button>
        </div>
      </div>
    </page-model>
  </div>
</template>

<script>
import PageModel from "./pageModel";
export default {
  components: { PageModel },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loadding: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    }
  },
  watch: {
    visible(val) {
      this.visibleValue = val;
    },
    loadding(val) {
      this.isLoadding = val;
    }
  },
  data() {
    return {
      visibleValue: this.visible,
      isLoadding: this.loadding
    };
  },
  methods: {
    closeModel() {
      this.$emit("close");
    },
    sureClick() {
      this.$emit("update:loadding", true);
      this.$emit("ok");
    }
  }
};
</script>

<style lang="scss" scoped>
.confirm {
  width: 386px;
  margin: 82px auto 0;
  .title {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .content {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-top: 72px;
  }
  .desc {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(164, 164, 164, 1);
    margin: 13px 0 24px 0;
  }
  .footer {
    width: 100%;
  }
}
</style>